import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({

})
export default class FinishPageComponents extends Vue {

    goHome() {
        this.$store.commit("clearStore");
        this.$router.push({ name: "Home" });
    }
}
